export default __webpack_public_path__ + "static/media/note.a9ac420f.svg";